import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import About from '../components/About';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import './LandingPage.css';

const LandingPage = () => {
    useEffect(() => {
        const cursor = document.createElement('div');
        cursor.className = 'custom-cursor';
        document.body.appendChild(cursor);

        const moveCursor = (e) => {
            cursor.style.left = `${e.clientX}px`;
            cursor.style.top = `${e.clientY}px`;
        };
        window.addEventListener('mousemove', moveCursor);
        return () => {
            window.removeEventListener('mousemove', moveCursor);
            document.body.removeChild(cursor);
        };
    }, []);

    useEffect(() => {
        const sections = Array.from(document.querySelectorAll('section'));
        if (sections.length === 0) return;

        const newHeight = window.innerHeight * 0.9;

        sections.forEach(section => {
            if (section.id !== 'projects') {
                section.style.height = `${newHeight}px`;
            }
            section.style.display = 'flex';
            section.style.flexDirection = 'column';
            section.style.justifyContent = 'center';
        });
    }, []);

    return (
        <>
            <Navbar />
            <About />
            <Experience />
            <Projects />
            <Contact />
        </>
    );
};

export default LandingPage;
